import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
    {
        id: "po-05-h0v5-01",
        name: "PO 01 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 82, y: 262, width: 200, height: 325, rotation: 0, imageRotation: 0 },
            { id: "2", x: 290, y: 262, width: 199, height: 325, rotation: 0, imageRotation: 0 },
            { id: "3", x: 497, y: 262, width: 199, height: 325, rotation: 0, imageRotation: 0 },
            { id: "4", x: 704, y: 262, width: 199, height: 325, rotation: 0, imageRotation: 0 },
            { id: "5", x: 911, y: 262, width: 199, height: 325, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-02",
        name: "PO 02 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 240, width: 232, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 240, y: 240, width: 232, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 480, y: 240, width: 232, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 720, y: 240, width: 231, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 240, width: 231, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-03",
        name: "PO 03 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 118, y: 282, width: 177, height: 287, rotation: 0, imageRotation: 0 },
            { id: "2", x: 303, y: 282, width: 176, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 622, y: 282, width: 176, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 282, width: 175, height: 287, rotation: 0, imageRotation: 0 },
            { id: "5", x: 989, y: 282, width: 175, height: 287, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-04",
        name: "PO 04 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 43, y: 167, width: 345, height: 515, rotation: 0, imageRotation: 0 },
            { id: "2", x: 396, y: 167, width: 163, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 396, y: 429, width: 163, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 234, width: 247, height: 382, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 234, width: 246, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-05",
        name: "PO 05 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 79, y: 165, width: 333, height: 520, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 165, width: 332, height: 520, rotation: 0, imageRotation: 0 },
            { id: "3", x: 420, y: 165, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 420, y: 341, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 420, y: 517, width: 109, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-06",
        name: "PO 06 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 92, y: 95, width: 411, height: 661, rotation: 0, imageRotation: 0 },
            { id: "2", x: 687, y: 95, width: 202, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 687, y: 430, width: 202, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 897, y: 95, width: 201, height: 327, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 430, width: 201, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-07",
        name: "PO 07 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 86, y: 226, width: 248, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 163, width: 163, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 429, width: 163, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 226, width: 248, height: 397, rotation: 0, imageRotation: 0 },
            { id: "5", x: 898, y: 226, width: 247, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-08",
        name: "PO 08 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 85, y: 91, width: 413, height: 651, rotation: 0, imageRotation: 0 },
            { id: "2", x: 652, y: 160, width: 328, height: 513, rotation: 0, imageRotation: 0 },
            { id: "3", x: 988, y: 160, width: 106, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 988, y: 334, width: 106, height: 166, rotation: 0, imageRotation: 0 },
            { id: "5", x: 988, y: 508, width: 106, height: 165, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-09",
        name: "PO 09 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 66, y: 182, width: 297, height: 484, rotation: 0, imageRotation: 0 },
            { id: "2", x: 371, y: 182, width: 146, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 371, y: 428, width: 146, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 525, y: 182, width: 295, height: 484, rotation: 0, imageRotation: 0 },
            { id: "5", x: 828, y: 182, width: 295, height: 484, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-10",
        name: "PO 10 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 67, y: 182, width: 296, height: 484, rotation: 0, imageRotation: 0 },
            { id: "2", x: 371, y: 182, width: 295, height: 484, rotation: 0, imageRotation: 0 },
            { id: "3", x: 674, y: 182, width: 295, height: 484, rotation: 0, imageRotation: 0 },
            { id: "4", x: 977, y: 182, width: 146, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 977, y: 428, width: 146, height: 238, rotation: 0, imageRotation: 0 }
        ],
    }
];